exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\nimg.centered-image {\n  display: block;\n  margin: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/maikelbald/laboratorio/NossaCidadeMelhor/angular-app/~/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/maikelbald/laboratorio/NossaCidadeMelhor/angular-app/~/postcss-loader?{"ident":"postcss"}!/Users/maikelbald/laboratorio/NossaCidadeMelhor/angular-app/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 6